import { json } from 'd3-fetch';
import { createSingleRaceFeed, createChoiceLookup } from './stores.js';
import { topojsonToGeoJson } from './utils/geography.js';
import {
  findElementByIdInShadowDom,
  renderSvelteComponent,
} from './utils/render.js';
import { GEOGRAPHY_URL } from './constants.js';
import ResultsBar from './components/ResultsBar.svelte';
import ResultsMap from './components/ResultsMap.svelte';

async function main() {
  const container = findElementByIdInShadowDom('ca-gov');
  const mapContainer = findElementByIdInShadowDom('ca-gov-map');
  if (!container || !mapContainer) return;

  // both at once: individual race file (CA_GOV_URL): one race, not an
  // array, with countyResults; and the map data
  const [govRace, topology] = await Promise.all([
    createSingleRaceFeed('CA-6123'),
    /** @type {Promise<import('topojson-specification').Topology>} */ (
      json(GEOGRAPHY_URL)
    ),
  ]);
  const crosswalk = window.CROSSWALK.assets.img;
  const [geography, /* roads, */ cities] = topojsonToGeoJson(topology, [
    'counties',
    // 'roads',
    'cities',
  ]);

  renderSvelteComponent(ResultsBar, container, {
    race: govRace,
    candidate1: '94', // Becerra
    candidate2: '172439', // Hilton
    candidateLookup: createChoiceLookup(govRace),
    crosswalk,
  });

  renderSvelteComponent(ResultsMap, mapContainer, {
    // the counties layer is all polygons, the cities layer all points
    geography:
      /** @type {import('./types').MapLayer<GeoJSON.Polygon | GeoJSON.MultiPolygon>} */ (
        geography
      ),
    // roads,
    cities: /** @type {import('./types').MapLayer<GeoJSON.Point>} */ (cities),
    feed: govRace,
  });
}

main().catch(console.error);
